<template>
    <div class="promo-code-table-component">

        <div class="row mb-3">
            <div class="col" v-show="enableFilter">
                <promo-code-filter @onFilter="onFilter" :isOpen="false"></promo-code-filter>
            </div>
            <div class="col text-end">
                <button class="btn btn-outline-secondary" @click="getList">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                         class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                        <path
                            d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                    </svg>
                </button>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col">
                        <h2>Promo Codes</h2>
                    </div>
                    <div class="col">
                        <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                                data-bs-target="#promo-code-modal-multi-add">
                            <span class="link-icon" data-feather="plus"></span> multi-adds
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <table class="table table-hover table-responsive align-middle">
                    <thead>
                    <tr>
                        <th><p class="text-end">id</p></th>
                        <th>code</th>
                        <th><p class="text-end">discount amount</p></th>
                        <th>expired date</th>
                        <th>active</th>
                        <th>used</th>
                        <th>plan</th>
                        <th>created date</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in promoCodes">
                        <td>
                            <p class="text-end">{{ row['id'] }}</p>
                        </td>
                        <td>
                            <p class="font-monospace">{{ row['code'] }}</p>
                        </td>
                        <td>
                            <p class="text-end">{{ row['discount_amount'] }}%</p>
                        </td>
                        <td>
                            <time :datetime="row['expired_at'] | formatUTC" :title="row['expired_at'] | formatUTC">
                                <span class="date">{{ row['expired_at'] | formatMoment('YYYY-MM-DD') }}</span>
                                <span class="time text-black-50">{{
                                        row['expired_at'] | formatMoment('HH:mm:ss')
                                    }}</span>
                                <span class="tz text-black-50 cursor-pointer">{{
                                        row['created_at'] | formatMoment('Z')
                                    }}</span>
                            </time>
                        </td>
                        <td>
                            <choise :value="row['is_active']" yesValue="Yes" noValue="No"/>
                            <button type="button" class="btn btn-outline-danger" v-if="row['is_active']"
                                    @click="deactivate(row['code'])">
                                deactivate
                            </button>
                        </td>
                        <td>
                            <choise :value="row['is_used']" yesValue="Yes" noValue="No"/>
                        </td>
                        <td>{{ row['plan_type'] }}</td>
                        <td>
                            <time :datetime="row['created_at'] | formatUTC" :title="row['created_at'] | formatUTC">
                                <span class="date">{{ row['created_at'] | formatMoment('YYYY-MM-DD') }}</span>
                                <span class="time text-black-50">{{
                                        row['created_at'] | formatMoment('HH:mm:ss')
                                    }}</span>
                                <span class="tz text-black-50 cursor-pointer">{{
                                        row['created_at'] | formatMoment('Z')
                                    }}</span>
                            </time>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="card-footer">

                <div class="row">

                    <div class="col">
                        <pagination
                            v-model="current_page"
                            @paginate="onPaginate"
                            :records="parseInt(rows_total)"
                            :per-page="parseInt(limit)"
                            :options="paginationOptions"
                        />
                    </div>

                    <div class="col-1" style="min-width: 125px;">
                        <form class="form-floating">
                            <select class="form-select form-select-sm"
                                    @change="current_page=1;getList()"
                                    v-model="limit">
                                <option value="7">7</option>
                                <option value="15">15</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="1000">1000</option>
                            </select>
                            <label>per page:</label>
                        </form>
                    </div>

                </div>

            </div>

        </div>

        <div class="modal" id="promo-code-modal-multi-add" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">PromoCode multi-adds</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="form-floating">
                            <input class="form-control" v-model="promoCodeNumber" type="number" min="1" step="1">
                            <label>Number of promo code</label>
                        </div>
                        <div class="form-floating">
                            <select v-model="promoCodeType" class="form-select">
                                <option value="month">Month</option>
                                <option value="year">Year</option>
                            </select>
                            <label>Activity</label>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="multiAdd">Add</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Pagination from "vue-pagination-2";
import UserAccessFilterForm from "../UserAccessFilterForm.vue";
import moment from "moment";

const content = document.querySelector('.promo-code-table-component')
const indexUrl = '/v4/promo-codes/list'
const multiAddUrl = '/v4/promo-codes/multi-create'
const changeActiveUrl = '/v4/promo-codes/change-active'

const _onErrorStatus = status => {
    if (status === 401) {
        location.href = '/logout'
        return true
    }

    if (status === 401) {
        content.innerHTML = '<div class="alert alert-danger" role="alert">\n' +
            '  You do not have permission to view this page.' +
            '</div>'
        return true
    }
}

const fetchJson = async options => {
    options = options || {}
    options['baseUrl'] = options['baseUrl'] || window.Laravel.API_HOSTNAME
    options['apiToken'] = options['apiToken'] || ''
    options['method'] = options['method'] || 'GET'
    options['url'] = options['url'] || ''
    if (options['url'] < '') {
        throw 'Url not set'
    }

    const init = {
        method: options.method,
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json",
            'Authorization': 'Bearer ' + options.apiToken,
        },
        redirect: "follow",
    }

    if (options['data'] !== undefined) {
        init['body'] = JSON.stringify(options['data'])
    }

    const res = await fetch(options['url'], init)
    const response = await res.json()

    res.ok || _onErrorStatus(res.status)

    return response;
}


export default {
    name: "PromoCodeTable",
    props: {
        apiUserToken: {
            type: String,
            required: true,
        },
        enableFilter: {
            type: Boolean,
            default: true,
            required: false,
        }
    },
    components: {
        UserAccessFilterForm,
        Pagination,
    },
    mounted() {
        this.getList()
    },
    data() {
        return {
            paginationOptions: {
                theme: "bootstrap4",
                edgeNavigation: true,
                texts: {
                    count: "{from} - {to} of {count} records|{count} records|One record",
                    first: "<<<",
                    last: ">>>",
                },
            },

            filters: {},
            promoCodes: {},
            current_page: 1,
            rows_total: 0,
            limit: 15,

            promoCodeType: 'month',
            promoCodeNumber: 100,
        }
    },
    methods: {
        async getList() {
            const fetchOptions = {apiToken: this.apiUserToken}
            fetchOptions['baseUrl'] = fetchOptions['baseUrl'] || window.Laravel.API_HOSTNAME
            fetchOptions['page'] = this.current_page
            fetchOptions['limit'] = this.limit
            fetchOptions['filters'] = this.filters

            const queryParams = {}
            if (fetchOptions['limit'] !== undefined) {
                queryParams['limit'] = fetchOptions['limit']
            }
            if (fetchOptions['page'] !== undefined) {
                queryParams['page'] = fetchOptions['page']
            }

            for (const i in fetchOptions.filters) {
                switch (typeof fetchOptions.filters[i]) {
                    case 'object':
                        if (fetchOptions.filters[i] instanceof Date) {
                            queryParams[i] = moment(fetchOptions.filters[i]).format('YYYY-MM-DD')
                        }
                        break;
                    case 'boolean':
                        queryParams[i] = fetchOptions.filters[i] ? 1 : 0
                        break;
                    case 'string':
                        if (fetchOptions.filters[i] > '') queryParams[i] = fetchOptions.filters[i]
                        break;
                }
            }

            const qs = new URLSearchParams(queryParams)
            fetchOptions['url'] = fetchOptions.baseUrl + indexUrl + (qs.size > 0 ? '?' + qs.toString() : '')

            const response = await fetchJson(fetchOptions)

            if (response.error !== undefined) {
                this.$root.$emit('onError.PromoCodeFetch', response)
                return
            }

            if (response.data !== undefined) {
                this.promoCodes = response.data
            }

            if (response.meta !== undefined) {
                this.current_page = response.meta.current_page || 1
                this.rows_total = response.meta.total || 7
            }
        },

        onFilter(data) {
            this.filters = data;
            this.getList()
        },

        onPaginate(page) {
            this.current_page = page
            this.getList()
        },

        async multiAdd() {
            const data = {
                'discount_count': this.promoCodeNumber,
                'plan_type': this.promoCodeType
            }
            const fetchOptions = {apiToken: this.apiUserToken}
            fetchOptions['baseUrl'] = fetchOptions['baseUrl'] || window.Laravel.API_HOSTNAME
            fetchOptions['url'] = fetchOptions.baseUrl + multiAddUrl
            fetchOptions['data'] = data
            fetchOptions['method'] = 'POST'
            const response = await fetchJson(fetchOptions)

            if (response.data.status === true) {
                await this.getList()
            }
        },

        async deactivate(code) {
            const data = {'promo_code': code}
            const fetchOptions = {apiToken: this.apiUserToken}
            fetchOptions['baseUrl'] = fetchOptions['baseUrl'] || window.Laravel.API_HOSTNAME
            fetchOptions['url'] = fetchOptions.baseUrl + changeActiveUrl
            fetchOptions['data'] = data
            fetchOptions['method'] = 'PUT'
            const response = await fetchJson(fetchOptions)

            if (response.data.status === true) {
                await this.getList()
            }
        },
    },
}
</script>